import IsValid from './IsValid';

/**
 * Class that allows you to chain together individual
 * validation rules
 */
export default class Rules {
	constructor() {
		this.rules = [];
		return this;
	}
	required(message = '') {
		// returns a named function to increase testability
		this.rules.push(function required(value) {
			return new IsValid(!!value, message, true);
		});
		return this;
	}
	maxLength(message = '', length) {
		this.rules.push(function maxLength(value) {
			return new IsValid(typeof value !== 'string' || !value || value.length <= length, message);
		});
		return this;
	}
	minLength(message = '', length) {
		this.rules.push(function minLength(value) {
			return new IsValid(typeof value !== 'string' || !value || value.length >= length, message);
		});
		return this;
	}
	email(message = '') {
		this.rules.push(function email(value) {
			const emailRegEx = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
			return new IsValid(emailRegEx.test(value), message);
		});
		return this;
	}
	done() {
		return this.rules;
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/validation/Rules.js